import React from 'react';
import { FontIcon } from 'material-ui';

export const openIcon = <FontIcon style={{ fontSize: 18 }} className="material-icons">open_in_full</FontIcon>;
export const closeIcon = <FontIcon style={{ fontSize: 18 }} className="material-icons">close_fullscreen</FontIcon>;



// WEBPACK FOOTER //
// ./src/containers/utils/icons.js